import { Checklist } from "./Checklist";
import { CompletionBar } from "./CompletionBar";

const TAB = "Vue Stratégique";

export default function VueStrategique() {
  return (
    <div className="space-y-12 pb-10" data-testid="vue-strategique">
      <CompletionBar tabName="Vue Strat\u00e9gique" />
      {/* Section 01 */}
      <section className="relative bg-white dark:bg-[#1a1a1a] rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-8 md:p-10 overflow-hidden shadow-xl dark:shadow-2xl dark:shadow-black/50">
        <div className="huge-number">01</div>
        <div className="card-content">
          <div className="mb-6 sm:mb-8">
            <h3 className="text-sm font-bold text-gray-500 dark:text-gray-400 tracking-[0.2em] uppercase mb-2">Fondations &amp; Systèmes</h3>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-gray-900 dark:text-white">Paramétrage et intégration</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 dark:bg-[#242424] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
              <div className="flex justify-between items-start mb-4">
                <span className="bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-400 text-xs font-bold px-2 py-1 rounded uppercase">Action Immédiate</span>
                <span className="stars text-sm">★★★★★</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Structure comptable &amp; analytique</h4>
              <Checklist tab={TAB} idPrefix="s1-compta" items={[
                "Valider le plan de comptes A3 (général + spécifique <abbr title='Bâtiment et Travaux Publics'>BTP</abbr>) et documenter le paramétrage",
                "Créer le plan analytique par chantier et les centres de coûts",
                "Aligner les codes chantiers entre BauBit Pro et A3",
                "Règle d'or\u00a0: «\u00a0aucune écriture sans chantier ou centre de coûts\u00a0»",
                "Finaliser la comptabilité 2025",
              ]} />
            </div>
            <div className="bg-gray-50 dark:bg-[#242424] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
              <div className="flex justify-between items-start mb-4">
                <span className="bg-[#e7f0e9] dark:bg-[rgba(46,109,59,0.22)] text-[#3f6947] dark:text-[#4d8a5b] text-xs font-bold px-2 py-1 rounded uppercase">Priorité Haute</span>
                <span className="stars text-sm">★★★★</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Interfaces et flux de données</h4>
              <Checklist tab={TAB} idPrefix="s1-flux" items={[
                "Paramétrer et tester les flux BauBit Pro → A3",
                "Paramétrer l'interface A3 Salaire → A3 Finance",
                "Définir les rapports de cohérence croisés et former les référents",
              ]} />
            </div>
          </div>
        </div>
      </section>

      {/* Section 02 */}
      <section className="relative bg-white dark:bg-[#1a1a1a] rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-8 md:p-10 overflow-hidden shadow-xl dark:shadow-2xl dark:shadow-black/50">
        <div className="huge-number">02</div>
        <div className="card-content">
          <div className="mb-8">
            <h3 className="text-sm font-bold text-gray-500 dark:text-gray-400 tracking-[0.2em] uppercase mb-2">Cycle Opérationnel &amp; Paie</h3>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-gray-900 dark:text-white">Gestion courante &amp; Clôture mensuelle</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 dark:bg-[#242424] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
              <div className="flex justify-between items-start mb-4">
                <span className="bg-[#eef4ef] dark:bg-[rgba(46,109,59,0.24)] text-[#4c7e55] dark:text-[#2e6d3b] text-xs font-bold px-2 py-1 rounded uppercase">Action Continue</span>
                <span className="stars text-sm">★★★</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Gestion courante &amp; Trésorerie</h4>
              <Checklist tab={TAB} idPrefix="s2-tresorerie" items={[
                "Organiser le flux de factures fournisseurs",
                "Paramétrer l'import des relevés bancaires et le lettrage",
                "Rapprochements bancaires mensuels et purger comptes d'attente",
              ]} />
            </div>
            <div className="bg-gray-50 dark:bg-[#242424] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
              <div className="flex justify-between items-start mb-4">
                <span className="bg-[#e7f0e9] dark:bg-[rgba(46,109,59,0.22)] text-[#3f6947] dark:text-[#4d8a5b] text-xs font-bold px-2 py-1 rounded uppercase">Priorité Haute</span>
                <span className="stars text-sm">★★★★★</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Paie mensuelle &amp; Clôture</h4>
              <Checklist tab={TAB} idPrefix="s2-paie" items={[
                "Mettre à jour les taux 2026\u00a0: <abbr title='Assurance-Vieillesse et Survivants'>AVS</abbr> (10,6\u00a0%), <abbr title='Assurance-Chômage'>AC</abbr> (1,10\u00a0% max), barèmes impôts",
                "Importer heures BauBit Pro, valider variables et générer virements",
                "Exécuter check-list de clôture mensuelle (intégration, édition rapports)",
              ]} />
            </div>
          </div>
        </div>
      </section>

      {/* Section 03 */}
      <section className="relative bg-white dark:bg-[#1a1a1a] rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-8 md:p-10 overflow-hidden shadow-xl dark:shadow-2xl dark:shadow-black/50">
        <div className="huge-number">03</div>
        <div className="card-content">
          <div className="mb-8">
            <h3 className="text-sm font-bold text-gray-500 dark:text-gray-400 tracking-[0.2em] uppercase mb-2">Clôtures &amp; Fiscalité</h3>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-gray-900 dark:text-white">Analyses et obligations légales</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 dark:bg-[#242424] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
              <div className="flex justify-between items-start mb-4">
                <span className="bg-[#edf3ee] dark:bg-[#263027] text-[#5e7462] dark:text-[#a8b7aa] text-xs font-bold px-2 py-1 rounded uppercase">Moyen Terme</span>
                <span className="stars text-sm">★★★★</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Bouclement annuel &amp; Gouvernance</h4>
              <Checklist tab={TAB} idPrefix="s3-gouv" items={[
                "Réaliser inventaire physique, révision des immos et provisions",
                "Éditer états financiers avant révision et <abbr title='Assemblée Générale'>AG</abbr>",
                "Tenir l'<abbr title='Assemblée Générale Ordinaire'>AGO</abbr> dans les 6 mois suivant la clôture",
                "Maintenir à jour le <abbr title='Registre du Commerce'>RC</abbr> et registre des actions",
              ]} />
            </div>
            <div className="bg-gray-50 dark:bg-[#242424] border border-gray-200 dark:border-gray-700 rounded-lg p-6">
              <div className="flex justify-between items-start mb-4">
                <span className="bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-400 text-xs font-bold px-2 py-1 rounded uppercase">Action Immédiate</span>
                <span className="stars text-sm">★★★★★</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Fiscalité</h4>
              <Checklist tab={TAB} idPrefix="s3-fisc" items={[
                "<strong class='text-gray-900 dark:text-white'><abbr title='Taxe sur la Valeur Ajoutée'>TVA</abbr>\u00a0:</strong> décompte et payer à 60 jours (taux 8,1\u00a0%, 2,6\u00a0%, 3,8\u00a0%)",
                "<strong class='text-gray-900 dark:text-white'><abbr title='Impôt Cantonal et Communal'>ICC</abbr>/<abbr title='Impôt Fédéral Direct'>IFD</abbr>\u00a0:</strong> déclarer avant le 30 avril. Provisionner l'<abbr title='Impôt Fédéral Direct'>IFD</abbr>",
                "<strong class='text-gray-900 dark:text-white'>Impôt anticipé\u00a0:</strong> payer 35\u00a0% sur dividendes dans les 30 jours",
                "<strong class='text-gray-900 dark:text-white'>Charges sociales\u00a0:</strong> payer <abbr title='Assurance-Vieillesse et Survivants'>AVS</abbr> le 10, impôt à la source dans les 30 jours",
                "<strong class='text-gray-900 dark:text-white'>Redevance radio-TV\u00a0:</strong> paiement annuel sur facturation",
              ]} />
            </div>
          </div>
        </div>
      </section>

      {/* Section 04 */}
      <section className="relative bg-white dark:bg-[#1a1a1a] rounded-xl border border-gray-200 dark:border-gray-800 p-4 sm:p-8 md:p-10 overflow-hidden shadow-xl dark:shadow-2xl dark:shadow-black/50">
        <div className="huge-number">04</div>
        <div className="card-content">
          <div className="mb-8">
            <h3 className="text-sm font-bold text-gray-500 dark:text-gray-400 tracking-[0.2em] uppercase mb-2">Processus <abbr title="Ressources Humaines">RH</abbr> &amp; Archivage</h3>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-black text-gray-900 dark:text-white">Cycle de vie &amp; Sécurisation</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 dark:bg-[#242424] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
              <div className="flex justify-between items-start mb-4">
                <span className="bg-[#e7f0e9] dark:bg-[rgba(46,109,59,0.22)] text-[#3f6947] dark:text-[#4d8a5b] text-xs font-bold px-2 py-1 rounded uppercase">Priorité Haute</span>
                <span className="stars text-sm">★★★★★</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Cycle de vie collaborateur</h4>
              <Checklist tab={TAB} idPrefix="s4-collab" items={[
                "<strong class='text-gray-900 dark:text-white'>Embauche\u00a0:</strong> affiliation <abbr title='Assurance-Vieillesse et Survivants'>AVS</abbr> (< 10 jours), <abbr title='Loi sur la Prévoyance Professionnelle'>LPP</abbr> (< 3 mois), <abbr title='Loi sur l&#39;Assurance-Accidents'>LAA</abbr>",
                "<strong class='text-gray-900 dark:text-white'>Vie contrat\u00a0:</strong> absences (certificat 3j), accidents (< 5j). Suivi télétravail (dès 2026)",
                "<strong class='text-gray-900 dark:text-white'>Départ\u00a0:</strong> résiliations, solde de compte (< 30 jours), certificat de travail",
              ]} />
            </div>
            <div className="bg-gray-50 dark:bg-[#242424] border border-gray-200 dark:border-gray-700 rounded-lg p-4 sm:p-6">
              <div className="flex justify-between items-start mb-4">
                <span className="bg-[#eef4ef] dark:bg-[rgba(46,109,59,0.24)] text-[#4c7e55] dark:text-[#2e6d3b] text-xs font-bold px-2 py-1 rounded uppercase">Action Continue</span>
                <span className="stars text-sm">★★★</span>
              </div>
              <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-4">Archivage légal &amp; Sécurité</h4>
              <Checklist tab={TAB} idPrefix="s4-archive" items={[
                "Conserver pendant <strong class='text-gray-900 dark:text-white'>10 ans</strong>\u00a0: compta, fiscalité, paie, juridique",
                "Conserver pendant <strong class='text-gray-900 dark:text-white'>20 ans</strong>\u00a0: biens immobiliers (TVA)",
                "Assurer sauvegarde numérique et conformité <abbr title='Loi fédérale sur la Protection des Données'>LPD</abbr>",
              ]} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
